export default {
  isPriority: false
};
